"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

require("./index.css");

var classnames_1 = __importDefault(require("classnames"));

var Button_1 = __importDefault(require("../../common/Button"));

var Banner = function (_a) {
  var text = _a.text,
      actions = _a.actions,
      grayText = _a.grayText,
      dataTestId = _a.dataTestId,
      className = _a.className,
      props = __rest(_a, ["text", "actions", "grayText", "dataTestId", "className"]);

  var hasActions = actions && actions.length > 0;
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    "data-testid": dataTestId,
    className: (0, classnames_1.default)('action-banner', className)
  }, props, {
    children: [(0, jsx_runtime_1.jsx)("div", __assign({
      className: (0, classnames_1.default)('text', {
        'has-actions': hasActions,
        'gray-text': grayText
      })
    }, {
      children: text
    }), void 0), hasActions && (0, jsx_runtime_1.jsx)("div", __assign({
      className: (0, classnames_1.default)('actions')
    }, {
      children: actions.map(function (_a) {
        var name = _a.name,
            action = _a.action,
            isPrimary = _a.isPrimary;
        return (
          /* @ts-ignore-next-line */
          (0, jsx_runtime_1.jsx)(Button_1.default, __assign({
            className: isPrimary ? undefined : 'button-outline',
            onClick: action
          }, {
            children: name
          }), name)
        );
      })
    }), void 0)]
  }), void 0);
};

exports.default = Banner;